import {
  Auditing,
  BooleanDict,
  FilterConfigs,
  Interest,
  Penalties,
  ReportingStatus,
} from '../types';

export const removeZeroTaxableReceipts = 'Remove $0 Taxable Receipts';
export const reported = 'Reported';
export const unreported = 'Unreported';
export const hasPenalties = 'Has Penalties';
export const noPenalties = 'No Penalties';
export const hasInterest = 'Has Interest';
export const noInterest = 'No Interest';
export const potentialTaxDiscrepancy = 'Potential tax discrepancy';

export const additionalFilterConfigs: FilterConfigs = [
  {
    groupName: 'Reporting Status',
    filters: [reported, unreported],
  },
  {
    groupName: 'Penalties',
    filters: [hasPenalties, noPenalties],
  },
  {
    groupName: 'Interest',
    filters: [hasInterest, noInterest],
  },
  {
    groupName: 'Auditing',
    filters: [potentialTaxDiscrepancy],
  },
  {
    groupName: 'Other',
    filters: [removeZeroTaxableReceipts],
  },
];

type Mapper<FilterGroup> = (filters: BooleanDict) => FilterGroup[];

function checkboxToFilterMapper<FilterGroup>(
  mapping: Map<string, FilterGroup>
): Mapper<FilterGroup> {
  return function (filters: BooleanDict) {
    const output: Array<FilterGroup> = [];

    mapping.forEach((value, key) => {
      if (filters[key]) {
        output.push(value);
      }
    });

    return output;
  };
}

export const reportingStatusFilter = checkboxToFilterMapper<ReportingStatus>(
  new Map([
    [reported, 'REPORTED'],
    [unreported, 'UNREPORTED'],
  ])
);

export const penaltiesFilter = checkboxToFilterMapper<Penalties>(
  new Map([
    [hasPenalties, 'HAS_PENALTY'],
    [noPenalties, 'NO_PENALTY'],
  ])
);

export const interestFilter = checkboxToFilterMapper<Interest>(
  new Map([
    [hasInterest, 'HAS_INTEREST'],
    [noInterest, 'NO_INTEREST'],
  ])
);

export const auditingFilter = checkboxToFilterMapper<Auditing>(
  new Map([[potentialTaxDiscrepancy, 'POTENTIAL_TAX_DISCREPANCY']])
);
